// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Box: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 36 33" enableBackground="new 0 0 36 33" xmlSpace="preserve">
<g fill="currentColor">
	<g>
		<path d="M33,9.62H2.75C2,9.62,1.38,10.25,1.38,11v20.62C1.38,32.38,2,33,2.75,33H33c0.75,0,1.38-0.62,1.38-1.38V11
			C34.38,10.25,33.75,9.62,33,9.62z M20.62,16.5h-5.5c-0.75,0-1.38-0.62-1.38-1.38s0.62-1.38,1.38-1.38h5.5
			c0.75,0,1.38,0.62,1.38,1.38S21.38,16.5,20.62,16.5z"/>
	</g>
	<g>
		<path d="M34.38,0h-33C0.62,0,0,0.62,0,1.38v5.5c0,0.75,0.62,1.38,1.38,1.38h33c0.75,0,1.38-0.62,1.38-1.38v-5.5
			C35.75,0.62,35.13,0,34.38,0z"/>
	</g>
</g>
</svg>;
};

export default React.memo(Box);
